// Configuration Google reCAPTCHA v3
// Pour obtenir ces clés : https://www.google.com/recaptcha/admin/create
// 1. Créez un compte Google
// 2. Choisissez "reCAPTCHA v3"
// 3. Ajoutez votre domaine : ars-agencement.bzh
// 4. Récupérez votre Site Key (clé publique)

export const RECAPTCHA_CONFIG = {
  // Clé publique reCAPTCHA v3 (visible dans le code, c'est normal)
  SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
  
  // Score minimum accepté (0.0 à 1.0, 0.5 recommandé)
  // Plus le score est élevé, plus il est probable que ce soit un humain
  MIN_SCORE: 0.5,
  
  // Activer/désactiver - Désactivé par défaut si pas de clé
  // Pour activer : ajouter REACT_APP_RECAPTCHA_SITE_KEY dans .env.local
  ENABLED: (process.env.REACT_APP_RECAPTCHA_ENABLED === 'true' && !!process.env.REACT_APP_RECAPTCHA_SITE_KEY)
};

// Debug en développement
if (process.env.NODE_ENV === 'development') {
  console.log('reCAPTCHA Config:', {
    enabled: RECAPTCHA_CONFIG.ENABLED,
    hasSiteKey: !!RECAPTCHA_CONFIG.SITE_KEY,
  });
}

// Instructions d'obtention de la clé :
// 1. Allez sur https://www.google.com/recaptcha/admin/create
// 2. Type de reCAPTCHA : "reCAPTCHA v3"
// 3. Domaines : ars-agencement.bzh, www.ars-agencement.bzh, localhost
// 4. Copiez la "Site Key" dans votre .env.local :
//    REACT_APP_RECAPTCHA_SITE_KEY=votre_clé_ici
